export default {
  methods: {
    handleErrors: function(response){
      console.log('handling errors:', response);
      if(response.errors?.length){
        // iterate returned errors
        for(var i = 0; i < response.errors.length; i++){
          this.displayError(response.errors[i]);
        }
      } else {
        // show single generic
        this.displayError({summary: 'Oops', detail: 'An unexpected error occurred. Please try again later.'});
      }
    },
    displayError: function(error){
      this.$toast.add({severity: 'error', summary: error.title, detail: error.detail, closable: true, sticky: true });
    }
  }
}
